import { useMemo } from 'react';

import { Controller } from '../types';
import { VisibilityController, VisibilityControllerId } from './types';

export const useVisibilityControl = (
  getControl: (controlId: string) => Controller | undefined
): VisibilityController => {
  const fallback: VisibilityController = useMemo(() => {
    return {
      id: VisibilityControllerId,
      handlers: {
        hide: () => {
          /**NOOP */
        },
        show: () => {
          /**NOOP */
        },
        isVisible: () => true,
      },
      hasControl: () => false,
    };
  }, []);

  return (getControl(VisibilityControllerId) as VisibilityController) || fallback;
};
